export const DEFAULT_CURRENCY = "AED";
export const DEFAULT_LOCALE = "en";
export const DEFAULT_MEASUREMENT = "imperial";
export const DEFAULT_COUNTRY = "AE";
export const storageUserCountry = "countryJeo";
export const supportedLang = {
  en: "en",
  ar: "ar",
  ru: "ru",
};
